import { useEffect, useState } from "react";
import { Image, Markdown } from "../../../atoms/components";
import {
  AnswerRequiredObject,
  ExamItemV2,
  InsideCourseResponses,
  OutsideCourseResponses,
} from "../../../pages/components/AssessmentViewerV2";
import { InputTextArea } from "../../../atoms/components";

export interface TextItemProps {
  item?: ExamItemV2;
  formData?: (data: any) => void;
  inputDisabled?: boolean;
  updateRequiredValue?: (requiredStateEntry: AnswerRequiredObject) => void;
}

export function TextItem({
  item,
  formData = () => {},
  inputDisabled,
  updateRequiredValue = (requiredStateEntry: {
    isAnswered: boolean;
    itemUuid: string;
  }) => {},
}: TextItemProps) {
  const [inputValue, setInputValue] = useState(
    item?.draftValue?.longInput || null
  );

  useEffect(() => {
    formData((values: any) => ({
      ...values,
      [item?.uuid || ""]: inputValue || "",
    }));
  }, []);

  useEffect(() => {
    if (item?.required) {
      updateRequiredValue({
        isAnswered: inputValue !== "",
        itemUuid: item?.uuid || "",
      });
    }
  }, [inputValue]);

  const onValueChange = (event: any) => {
    setInputValue(event.target.value);
    formData((values: any) => ({
      ...values,
      [item?.uuid || ""]: event.target.value,
    }));
  };
  return (
    <div className="mb-8">
      <div className="text-lg font-bold">
        <span className="text-error-500">{item?.required ? "* " : ""}</span>
        <Markdown text={item?.text || ""} />
      </div>
      <div className={`py-4 ${item?.mediaUrl ? "" : "hidden"}`}>
        <Image
          src={item?.mediaUrl || ""}
          alt={item?.mediaUrl || ""}
          className={`w-full min-h-40 max-h-[35rem] object-contain bg-opacity-0`}
        />
      </div>

      <InputTextArea
        disabled={inputDisabled}
        onChange={onValueChange}
        rows={4}
        name={item?.uuid || ""}
        value={inputValue || ""}
      />
    </div>
  );
}
